"use client";
import { LayoutGroup } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { ExpandableCard } from "./Card";
import { useWindowSize } from "@/hooks/use-window-size";
import { AwardCategoryProps } from "@/services/home/types";
import { useLocaleCtx } from "@/contexts/locale";
import { Reveal } from "@/components/ui/animations";
import useClickOutside from "@/hooks/use-click-outside";

type DesktopProps = {
  data: AwardCategoryProps[];
};

export default function DesktopCards({ data }: DesktopProps) {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [isLayoutExpanded, setIsLayoutExpanded] = useState(false);
  const [cardWidth, setCardWidth] = useState("300px");
  const { width } = useWindowSize();
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const cardRef = useRef<HTMLDivElement | null>(null);

  useClickOutside(cardRef, handleClose);

  function handleClose() {
    setExpandedIndex(null);
    setIsLayoutExpanded(false);
  }

  const { lang } = useLocaleCtx();

  useEffect(() => {
    if (width > 1280) {
      setCardWidth("216px");
    }

    if (width > 1400) {
      setCardWidth("240px");
    }

    if (width > 1650) {
      setCardWidth("280px");
    }
  }, [width]);

  return (
    <Reveal once={false} className="grid grid-cols-5 gap-4">
      <LayoutGroup>
        {data.slice(0, 5).map((card, index) => (
          <div key={index} ref={expandedIndex === index ? cardRef : undefined}>
            <ExpandableCard
              onHover={() => setHoveredIndex(index)}
              onHoverEnd={() => setHoveredIndex(null)}
              lang={lang}
              hoveredIndex={hoveredIndex}
              key={String(index)}
              title={card.title}
              description={card?.description ?? ""}
              isExpanded={expandedIndex === index}
              isLayoutExpanded={isLayoutExpanded}
              onClick={() => {
                setExpandedIndex(index);
                setIsLayoutExpanded(true);
              }}
              onClose={handleClose}
              index={index}
              cardWidth={cardWidth}
            />
          </div>
        ))}
      </LayoutGroup>
    </Reveal>
  );
}
